import { useEffect, useState } from "react";
import AppHeaderBar from "../AppHeaderBar";
import AppNavBar from "../AppNavBar";
import { useTranslation } from "react-i18next";
import AppCollectRow from "./AppCollectRow";
import { LoadingScreen } from "../../components/loader/LoadingScreen";
import { sendPlanningMail } from "../../containers/container/utilsTable";
import { Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { capitalizeFirstLetter } from "../../components/utils/Date";
import { FaMapMarkerAlt } from "react-icons/fa";
import MobileForbiddenModule from "../MobileForbiddenModule";
import { hasMonitoringModule } from "../mobileModuleUtils";
import { fetchMonitoringGroupedContainers } from "./monitoringListUtils";

const AppCollect = ({ setCookies, saveUser }) => {
  const { t } = useTranslation();
  const monitoringEnabled = hasMonitoringModule();
  const [containers, setContainers] = useState([]);
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [containersSelected, setContainersSelected] = useState([]);
  const [confimationCollectModal, setConfirmationCollectModal] =
    useState(false);
  const [modalContainer, setModalContainer] = useState(null);
  const [alertType, setAlertType] = useState(null);

  useEffect(() => {
    if (!monitoringEnabled) {
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const { groupedContainers, settings: settingsData } =
          await fetchMonitoringGroupedContainers();
        setContainers(groupedContainers);
        if (settingsData) {
          setSettings(settingsData);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [monitoringEnabled]);

  const toggle = () => {
    setConfirmationCollectModal(!confimationCollectModal);
    setContainersSelected([]);
  };

  const handlePlannig = async () => {
    setLoading(true);
    await sendPlanningMail(containersSelected, alertType);
    if (alertType === "rotation") {
      const updatedContainers = Object.fromEntries(
        Object.entries(containers).map(([address, containerList]) => {
          const newList = containerList.map((elt) => {
            const isSelected = containersSelected.some(
              (container) => container._id === elt._id,
            );
            return isSelected
              ? { ...elt, status: "remove_driver_exchange" }
              : elt;
          });

          return [address, newList];
        }),
      );
      setContainers(updatedContainers);
    }
    setAlertType(null);
    setContainersSelected([]);
    setConfirmationCollectModal(!confimationCollectModal);
    setLoading(false);
  };

  const addressKeys = Object.keys(containers).filter(
    (address) => containers[address].length > 0,
  );

  return (
    <div className="installation-list-page monitoring-list-page">
      <AppHeaderBar
        title={capitalizeFirstLetter(t("Monitoring"))}
        setCookies={setCookies}
        saveUser={saveUser}
      />

      <div className="installation-list-shell">
        {!monitoringEnabled && <MobileForbiddenModule viewType="monitoring" />}

        {monitoringEnabled && loading && <LoadingScreen />}

        {monitoringEnabled && !loading && addressKeys.length === 0 && (
          <div className="installation-subpage-card monitoring-empty-card">
            <p className="installation-subpage-card-text">{t("No data")}</p>
          </div>
        )}

        {monitoringEnabled && !loading && addressKeys.length > 0 && (
          <div className="installation-list">
            {addressKeys.map((address) => (
              <section key={address} className="installation-address-group">
                <h2 className="installation-address-heading">
                  <FaMapMarkerAlt
                    className="installation-address-heading-icon"
                    aria-hidden
                  />
                  <span
                    className="installation-address-heading-text"
                    title={address}
                  >
                    {address}
                  </span>
                </h2>
                <div className="installation-address-cards">
                  {containers[address].map((container) => (
                    <AppCollectRow
                      key={container._id}
                      container={container}
                      containersSelected={containersSelected}
                      setContainersSelected={setContainersSelected}
                      setConfirmationCollectModal={setConfirmationCollectModal}
                      settings={settings}
                      modalContainer={modalContainer}
                      setModalContainer={setModalContainer}
                      setAlertType={setAlertType}
                    />
                  ))}
                </div>
              </section>
            ))}
          </div>
        )}
      </div>

      {monitoringEnabled && confimationCollectModal && (
        <Modal
          isOpen={confimationCollectModal}
          toggle={toggle}
          className="monitoring-modal"
        >
          <section className="monitoring-modal-header">
            <h6 className="monitoring-modal-title">
              {alertType === "rotation"
                ? t("schedule_pickup")
                : t("request_compaction")}
            </h6>
            <FontAwesomeIcon
              icon="times"
              className="monitoring-modal-close"
              onClick={() => toggle()}
            />
          </section>

          <section className="monitoring-modal-body">
            <p>{`${alertType === "rotation" ? t("confirm_schedule_pickup") : t("confirm_request_compaction")} ?`}</p>
          </section>

          <section className="monitoring-modal-actions">
            <button
              type="button"
              onClick={() => toggle()}
              className="monitoring-modal-button monitoring-modal-button-secondary"
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="monitoring-modal-button monitoring-modal-button-primary"
              onClick={() => {
                handlePlannig();
              }}
            >
              {alertType === "rotation"
                ? t("schedule_pickup")
                : t("request_compaction")}
            </button>
          </section>
        </Modal>
      )}

      <AppNavBar />
    </div>
  );
};

export default AppCollect;
